<template>

  <div class="menu-list" :style="{ 'z-index': getZIndex}" ref="menulist">

    <ul class="menu-items" v-if="horizontal">

      <menu-list-item :item="item"
                       v-for="(item, index) in items"
                       :key="index"
                       :style="{ width: getMaxItemWidth(items), height: getMaxItemHeight(items), 'line-height': getMaxItemHeight(items) }"/>

    </ul>

    <template v-else>

      <ul class="menu-items"
          @mouseover="showMenu"
          @mouseout="hideMenu"
          @click="onMenuClick">

        <menu-list-item :style="{ width: width + 'px', height: height + 'px', 'line-height': height + 'px' }"
                        :item="{ label: menuText, width: width, height: height, icon: menuIcon, showCaret: true }"
                        class="options-menu-item"/>

      </ul>

      <ul class="menu-items options-menu"
                  :tabindex="0"
                  v-show="openMenu"
                  @mouseover="showMenu"
                  @mouseout="hideMenu">

        <menu-list-item :item="item"
                         v-for="(item, index) in items"
                         :key="index"
                         :style="{ width: getMaxItemWidth(items), height: getMaxItemHeight(items), 'line-height': getMaxItemHeight(items) }"
                         @click="openMenu = false"/>

      </ul>

    </template>

  </div>

</template>

<script>

  import zIndexMixins from '../../../mixins/zIndexMixins';

  export default {

    mixins: [zIndexMixins],

    props: {
      items: {
        type: Array
      },
      width: {
        type: Number,
        default: 150
      },
      horizontal: {
        type: Boolean,
        default: true
      },
      menuIcon: {
        type: String,
        required: false
      },
      menuText: {
        type: String,
        required: false
      },
      showMenuOnHover: {
        type: Boolean,
        default: true
      },
      height: {
        type: Number,
        default: 25
      }
    },

    data() {
      return {
        openMenu: false
      }
    },

    created() {
      document.addEventListener('click', this.documentClick);

      this.$on('zIndexChange', () => {
        this.openMenu = false;
      });
    },

    methods: {

      documentClick(e) {
        let el = this.$refs.menulist;
        let target = e.target;
        if (!el)
          return;
        if ( el !== target && !el.contains(target) ) {
          this.openMenu = false;
        }
      },

      showMenu(item) {
        if (this.showMenuOnHover) {
          this.setZIndex();
          this.openMenu = true;
        }
      },

      hideMenu(item) {
        if (this.showMenuOnHover)
          this.openMenu = false;
      },

      onMenuClick(item) {
        if (!this.showMenuOnHover) {
          this.setZIndex();
          this.openMenu = true;
        }
      },

      getMaxItemWidth(items) {

        var widthList = items.filter((c) => {
          return c.width;
        }).map((c) => {
          return c.width;
        });

        if (widthList.length == 0)
          return '150px';

        return Math.max.apply(null, widthList) + 'px';
      },

      getMaxItemHeight(items) {

        var heightList = items.filter((c) => {
          return c.height;
        }).map((c) => {
          return c.height;
        });

        if (heightList.length == 0)
          return '25px';

        return Math.max.apply(null, heightList) + 'px';
      }

    }

  }

</script>

<style lang="scss">

  .menu-list {

    display: inline-block;
    position: relative;

    .menu-items {
      margin: 0;
      padding: 0;
      list-style: none;
      display: inline-block;
      outline: none;
    }

    .options-menu {

      position: absolute;

      .options-menu-item {
        border-bottom: 1px solid #ddd;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Common/MenuList/MenuList.vue